import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCart, GetCartApiParameter, updateCart } from "@insite/client-framework/Services/CartService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState, isCartEmpty } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import addCartLines from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { canAddWishListLineToCart } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import addLinesToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";
import clearCurrentCart from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import translate from "@insite/client-framework/Translate";
import { CartLineCollectionModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddedToCartMessage from "@insite/content-library/Components/ProductAddedToCartMessage";
import { StaticListPageContext } from "@insite/content-library/Pages/StaticListPage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ValidateWishListLineCollection } from "@MasterBluePrint/Components/MsqValidation";
import { getQuoteState } from "@MasterBluePrint/Store/Data/Quotes/QuotesSelector";
import  addToCartCollectionTracking  from "@MasterBluePrint/Tracking/AddToCart/addToCartCollectionTracking";
import { Draft } from "immer";
import cloneDeep from "lodash/cloneDeep";
import React, { useEffect, useState } from "react";
import { connect, HandleThunkActionCreator, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    updateCartLine: HandleThunkActionCreator<typeof updateCartLine>;
}

interface OwnProps {
    updateCartLine: HandleThunkActionCreator<typeof updateCartLine>;
}
const mapStateToProps = (state: ApplicationState) => {
    const wishListState = getWishListState(state, state.pages.staticList.wishListId);
    const wishListLines = wishListState.value?.wishListLineCollection;
    const productInfosByWishListLineId = state.pages.staticList.productInfosByWishListLineId;
    const cartState = getCurrentCartState(state);
    const cart = cartState.value;
    return {
        session: getSession(state),
        wishListState,
        productInfosByWishListLineId,
        myListsDetailsPageUrl: getPageLinkByPageType(state, "MyListsDetailsPage")?.url,
        showAddToCartConfirmationDialog: getSettingsCollection(state).productSettings.showAddToCartConfirmationDialog,
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        location: getLocation(state),
        canAddAllToCart: wishListLines?.every(o => canAddWishListLineToCart(o, productInfosByWishListLineId)) || false,
        state,
        quoteState: getQuoteState(state, wishListState.value?.description),
        isCartEmpty: isCartEmpty(cart),
        cartState,
    };
};

const mapDispatchToProps = {
    addToWishList,
    addCartLines,
    loadCurrentCart,
    updateCartLine,
    addLinesToCart,
    clearCurrentCart,
};

type Props = OwnProps &
    WidgetProps &
    HasHistory &
    HasToasterContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

export interface StaticListHeaderStyles {
    container?: GridContainerProps;
    infoGridItem?: GridItemProps;
    nameText?: TypographyPresentationProps;
    sharedByText?: TypographyPresentationProps;
    saveListGridItem?: GridItemProps;
    saveListButton?: ButtonPresentationProps;
    addListToCartGridItem?: GridItemProps;
    addListToCartButton?: ButtonPresentationProps;
    saveListModal?: ModalPresentationProps;
    signInMessageText?: TypographyPresentationProps;
    descriptionText?: TypographyPresentationProps;
    listNameTextField?: TextFieldPresentationProps;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    saveButton?: ButtonPresentationProps;
}

export const staticListHeaderStyles: StaticListHeaderStyles = {
    container: {
        gap: 10,
        css: css`
            padding-bottom: 0.625rem;
            & > div {
                justify-content: space-between;
            }
        `,
    },
    infoGridItem: {
        width: [12, 12, 6, 7, 8],
        css: css`
            flex-direction: column;
        `,
    },
    nameText: {
        variant: "h1",
    },
    saveListGridItem: {
        width: [12, 12, 3, 2, 2],
        css: css`
            justify-content: flex-end;
        `,
    },
    saveListButton: {
        variant: "secondary",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    addListToCartGridItem: {
        width: [12, 12, 3, 3, 2],
    },
    addListToCartButton: {
        css: css`
            width: 100%;
        `,
    },
    saveListModal: {
        sizeVariant: "small",
    },
    listNameTextField: {
        cssOverrides: {
            formField: css`
                margin-top: 1.25rem;
            `,
        },
    },
    buttonsWrapper: {
        css: css`
            margin-top: 1.25rem;
            text-align: right;
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
    saveButton: {
        css: css`
            margin-left: 0.625rem;
        `,
    },
};

const styles = staticListHeaderStyles;

const StaticListHeader = ({
    session,
    wishListState,
    productInfosByWishListLineId,
    myListsDetailsPageUrl,
    showAddToCartConfirmationDialog,
    signInUrl,
    location,
    canAddAllToCart,
    history,
    toaster,
    addToWishList,
    addCartLines,
    loadCurrentCart,
    state,
    updateCartLine,
    quoteState,
    addLinesToCart,
    clearCurrentCart,
    isCartEmpty,
    cartState,
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const quote = quoteState.value;
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const saveListClickHandler = () => {
        setModalIsOpen(true);
    };

    const [listName, setListName] = useState("");
    const [listNameError, setListNameError] = useState("");
    const listNameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setListName(e.currentTarget.value);
        setListNameError("");
    };

    const [isCartCleared, setIsCartCleared] = useState(false);
    useEffect(() => {
        if (typeof isCartEmpty !== "undefined" && !isCartEmpty && isCartCleared && cartState.isLoading) {
            addToCartClickHandler();
            setIsCartCleared(false);
        }
    }, [isCartEmpty, isCartCleared, cartState.isLoading]);

    const addToCartClickHandler = () => {
        if (!quote || !quote.cartLines) {
            return;
        }
        const cartLines: CartLineModel[] = [];
        quote?.cartLines?.forEach((cartLine: CartLineModel) => {
            const cartLineClone = cloneDeep(cartLine) as CartLineModel;
            cartLineClone.properties = {
                InQuote: "true",
            };
            cartLines.push(cartLineClone);
        });
        addLinesToCart({
            apiParameter: {
                cartId: API_URL_CURRENT_FRAGMENT,
                cartLineCollection: { cartLines } as CartLineCollectionModel,
            },
            onSuccess: async () => {
                if (showAddToCartConfirmationDialog) {
                    toaster.addToast({ body: siteMessage("Cart_AllProductsAddedToCart"), messageType: "success" });
                }
                const cartData = await getCart({ cartId: API_URL_CURRENT_FRAGMENT } as GetCartApiParameter);
                const { cart } = cartData;
                if (cart.lineCount > 0) {
                    const cartClone = cloneDeep(cart) as Draft<typeof cart>;
                    cartClone.properties = {
                        isquote: JSON.stringify(true),
                        quoteNumber: quote.orderNumber,
                        termsCode: quote.properties.termsCode,
                        customerFreightBillingAcctNumber: quote.properties.customerFreightBillingAcctNumber,
                    };
                    await updateCart({ cart: cartClone });
                }
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    this.onSuccess?.();
                }
            },
        });
    };

    const AddQuoteToCart = () => {
        if (!isCartEmpty && !isCartCleared) {
            clearCurrentCart();
            setIsCartCleared(true);
        } else {
            addToCartClickHandler();
        }
    };

    const saveListButtonClickHandler = () => {
        const wishListLines = wishListState.value?.wishListLineCollection;
        if (!wishListLines || wishListLines.length === 0) {
            return;
        }

        const productInfos = wishListLines.map(o => productInfosByWishListLineId[o.id]!);
        addToWishList({
            newListName: listName,
            productInfos,
            onSuccess: ({ id }) => {
                setModalIsOpen(false);
                if (myListsDetailsPageUrl) {
                    history.push(`${myListsDetailsPageUrl}?id=${id}`);
                }
            },
            onError: errorMessage => {
                setListNameError(errorMessage);
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.result.wishList);
                } else if (resultProps.result?.errorMessage) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };

    const addListToCartClickHandler = () => {
        const wishListLines = wishListState.value?.wishListLineCollection;
        if (!wishListLines || wishListLines.length === 0) {
            return;
        }
        const currentUrl = window.document.URL;
        const pageSourceResult = currentUrl.toLowerCase().includes("search")
            ? "Search Results"
            : currentUrl.toLowerCase().includes("checkout/review")
              ? "Order Review"
              : currentUrl.toLowerCase().includes("brand")
                ? "Brand Results"
                : currentUrl.toLowerCase().includes("quote/confirmation")
                  ? "Quote Confirmation"
                  : currentUrl.toLowerCase().includes("mylists")
                    ? "Product Wish List"
                    : currentUrl.toLowerCase().includes("category")
                      ? "Category Results"
                      : currentUrl.toLowerCase().includes("staticlist")
                        ? "Shared Cart"
                        : "Product Details";
        let listId: any;
        if (pageSourceResult === "Shared Cart") {
            const wishListState = getWishListState(state, state.pages.staticList.wishListId);
            const wishList = wishListState.value;
            listId = wishList?.id;
        }
        const productInfos = wishListLines.map(o => productInfosByWishListLineId[o.id]!);
        if (!ValidateWishListLineCollection(wishListLines)) {
            toaster.addToast({
                body: siteMessage(
                    "Core_WishlistLineMultipleSaleQtyErrorSpire",
                    "",
                    "Quantities in list do not meet mutiple sale quantity and need to be changed before adding the list to cart",
                ),
                messageType: "danger",
            });
            return;
        }
        addCartLines({
            productInfos,
            onSuccess: (cartLinesCollection: CartLineCollectionModel) => {
                addToCartCollectionTracking(cartLinesCollection, state);
                loadCurrentCart({ shouldLoadFullCart: true });
                if (showAddToCartConfirmationDialog) {
                    const isQtyAdjusted =
                        cartLinesCollection.cartLines?.some(cartLine => cartLine.isQtyAdjusted) ?? false;

                    toaster.addToast({
                        body: <ProductAddedToCartMessage isQtyAdjusted={isQtyAdjusted} multipleProducts={true} />,
                        messageType: "success",
                    });
                }
                cartLinesCollection.cartLines?.forEach(line => {
                    updateCartLine({
                        cartLine: {
                            ...line,
                            properties: {
                                productSourceActionField: pageSourceResult,
                                listIdField: listId,
                            },
                        },
                    });
                });
            },
            onComplete(resultProps) {
                if (resultProps.apiResult?.cartLines) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.apiResult);
                }
            },
        });
    };

    if (wishListState.isLoading || !wishListState.value) {
        return null;
    }

    const wishList = wishListState.value;
    const WishListName = wishList.name;
    const Name = WishListName.lastIndexOf("-");
    const WishID = WishListName.split("-");
    const CartID = WishID[1];
    const SharerName = WishListName.slice(0, Name);
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const allQtysIsValid = wishList.wishListLineCollection?.every(
        o => !!productInfosByWishListLineId[o.id] && productInfosByWishListLineId[o.id]!.qtyOrdered > 0,
    );
    return (
        <>
            <GridContainer {...styles.container}>
                <GridItem {...styles.infoGridItem}>
                    <Typography {...styles.nameText} as="h1">
                        {!quoteState.value && <>{`${translate("Cart")} #${CartID}`}</>}
                        {quoteState.value && <>{`${translate("Quote")} #${CartID}`}</>}
                    </Typography>
                    <Typography {...styles.sharedByText}>
                        {!quoteState.value && (
                            <>
                                {`${translate("Shared by")} ${wishList.sharedByDisplayName ? wishList.sharedByDisplayName : SharerName}`}
                            </>
                        )}
                        {quoteState.value && (
                            <>
                                {`${translate("Quote for")} ${wishList.sharedByDisplayName ? wishList.sharedByDisplayName : SharerName}`}
                            </>
                        )}
                    </Typography>
                </GridItem>
                <GridItem {...styles.saveListGridItem}>
                    {!quoteState.value && (
                        <>
                            <Button {...styles.saveListButton} onClick={saveListClickHandler}>
                                {translate("Save List")}
                            </Button>
                        </>
                    )}
                </GridItem>
                {canAddAllToCart && (
                    <GridItem {...styles.addListToCartGridItem}>
                        {!quoteState.value && (
                            <>
                                <Button
                                    {...styles.addListToCartButton}
                                    disabled={!allQtysIsValid}
                                    onClick={addListToCartClickHandler}
                                >
                                    {translate("Add List to Cart")}
                                </Button>
                            </>
                        )}
                        {quoteState.value && (
                            <>
                                <Button
                                    {...styles.addListToCartButton}
                                    onClick={AddQuoteToCart}
                                    data-test-selector="quote-to-cart-btn"
                                >
                                    {translate("Add this Quote to Cart")}
                                </Button>
                            </>
                        )}
                    </GridItem>
                )}
            </GridContainer>
            <Modal
                {...styles.saveListModal}
                headline={isAuthenticated ? translate("Save List") : translate("Please Sign In")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                {!isAuthenticated && (
                    <Typography {...styles.signInMessageText}>
                        {siteMessage(
                            "Lists_SignIn_Required_To_Save_List_In_Spire",
                            `${signInUrl}?returnUrl=${encodeURIComponent(location.pathname + location.search)}`,
                        )}
                    </Typography>
                )}
                {isAuthenticated && (
                    <>
                        <Typography {...styles.descriptionText}>
                            {translate("Enter a name for the new list.")}
                        </Typography>
                        <TextField
                            {...styles.listNameTextField}
                            label={translate("New List Name")}
                            labelPosition="left"
                            value={listName}
                            error={listNameError}
                            onChange={listNameChangeHandler}
                        />
                        <StyledWrapper {...styles.buttonsWrapper}>
                            <Button {...styles.cancelButton} onClick={modalCloseHandler}>
                                {translate("Cancel")}
                            </Button>
                            <Button {...styles.saveButton} onClick={saveListButtonClickHandler}>
                                {translate("Save List")}
                            </Button>
                        </StyledWrapper>
                    </>
                )}
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withToaster(StaticListHeader))),
    definition: {
        group: "Static List",
        displayName: "Page Header",
        allowedContexts: [StaticListPageContext],
    },
};

export default widgetModule;
